<template>
  <div class="box wrapper-payroll-inability">
    <div class="title-container is-flex">
      <h4 class="title is-centered is-4 has-text-primary title-payroll-inability">
        Incapacidades
      </h4>
      <div class="field is-centered">
        <BTooltip
          class="add-button"
          label="Agregar incapacidad"
          type="is-success"
        >
          <a
            class="button add-paidLeave is-success is-rounded"
            @click="$store.commit('payroll/addPaidLeaveRow')"
          >
            <BIcon icon="plus" />
          </a>
        </BTooltip>
      </div>
    </div>
    <BTable
      :data="paidLeavesWithIndex"
      :columns="columns"
    >
      <template slot-scope="props">
        <BTableColumn
          class="limit-300"
          field="paidLeaveType"
          internal
        >
          <BField>
            <BSelect
              name="paidLeaveType"
              placeholder="Selecciona el tipo"
              :value="props.row.paidLeaveType"
              class="is-fullwidth"
              :disabled="loading"
              :loading="loading"
              required
              @input="onInput(props.row.id, 'paidLeaveType', $event)"
            >
              <option
                v-for="option in paidLeaveTypeCatalog"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </BSelect>
          </BField>
        </BTableColumn>
        <BTableColumn
          field="daysOfPaidLeave"
          internal
        >
          <BField>
            <BInput
              name="daysOfPaidLeave"
              placeholder="Ingresa el número de días"
              type="number"
              min="0"
              step="0.01"
              :value="props.row.daysOfPaidLeave"
              required
              @input="onInput(props.row.id, 'daysOfPaidLeave', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="amount"
          internal
        >
          <BField>
            <BInput
              name="amount"
              placeholder="Ingresa el monto a pagar"
              type="number"
              min="0"
              :value="props.row.amount"
              required
              @input="onInput(props.row.id, 'amount', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="actions"
          internal
        >
          <span class="actions">
            <a
              class="button is-danger"
              @click="$store.commit('payroll/deletePaidLeave', props.row.id)"
            >
              <BIcon
                icon="delete"
                aria-hidden="true"
              />
            </a>
          </span>
        </BTableColumn>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <BIcon
                icon="emoticon-sad"
                size="is-large"
              />
            </p>
            <p>No has agregado incapacidades</p>
          </div>
        </section>
      </template>
    </BTable>
  </div>
</template>

<script>
import { payLeaveType as payLeaveTypeCatalog } from '@machete/common-catalogs';

const normalizeCatalog = ({ key, value }) => ({ value: key, label: value });

export default {
  name: 'PayrollPaidLeaves',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paidLeaveTypeCatalog: payLeaveTypeCatalog.map(normalizeCatalog),
      columns: [
        { field: 'paidLeaveType', label: 'Tipo de incapacidad', centered: true },
        { field: 'daysOfPaidLeave', label: 'Días de incapacidad', centered: true },
        { field: 'amount', label: 'Monto', centered: true },
        { field: 'actions', label: '', centered: true },
      ],
    };
  },
  computed: {
    paidLeavesWithIndex() {
      return this.$store.state.payroll.paidLeaves.map((paidLeave, index) => ({
        ...paidLeave,
        id: index,
      }));
    },
  },
  methods: {
    onInput(index, name, value) {
      this.$store.commit('payroll/changePaidLeave', { index, name, value });
    },
  },
};
</script>

<style scoped>
.title.is-4 {
  margin-bottom: 0;
}

.header-label {
  padding-right: 0.25rem;
}

.add-button {
  margin-right: 1.5rem;
}

.button.add-paidLeave {
  padding-left: 0.75em!important;
  padding-right: 0.75em!important;
}

.button.add-paidLeave .icon {
  margin-left: calc(-0.375em - 1px)!important;
  margin-right: calc(-0.375em - 1px)!important;
  font-size: inherit!important;
}

.add-paidLeave-label {
  padding-left: .5rem;
}

.title-container {
  width: 100%;
  align-items: center;
  padding-bottom: .3rem;
  justify-content: space-between;
}

.limit-300 {
  width: 300px;
}
</style>
